import { render, staticRenderFns } from "./addedit.vue?vue&type=template&id=4b288a1d"
import script from "./addedit.vue?vue&type=script&lang=js"
export * from "./addedit.vue?vue&type=script&lang=js"
import style0 from "./addedit.vue?vue&type=style&index=0&id=4b288a1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports